// extracted by mini-css-extract-plugin
export var layoutContainer = "_8v-0";
export var layoutContainerNoRounding = "_8v-6";
export var layoutContainerOpen = "_8v-5";
export var layoutContainerResizing = "_8v-1";
export var mainContent = "_8v-2";
export var resizeDivider = "_8v-3";
export var slidePanel = "_8v-4";